import { atom } from "recoil";

export const currentGroupState = atom<IGroup | null>({
  key: 'CurrentGroupState',
  default: null,
});
